import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { useEditor } from "./editor/store.js";
// the editor store on window: lets scripted checks drive the studio exactly like the UI does
(window as unknown as { __studio: typeof useEditor }).__studio = useEditor;
import "./theme.css";
import { applyTheme, getTheme } from "./theme.js";
applyTheme(getTheme());
import { App } from "./App.js";
import { ToastProvider } from "./components/Toast.js";
import { ErrorBoundary } from "./components/ErrorBoundary.js";
import { Gate } from "./components/Gate.js";

// keep the last unhandled error around: a blank page tells us nothing, this does
window.addEventListener("error", (e) => { try { localStorage.setItem("studio.lastError", JSON.stringify({ at: new Date().toISOString(), message: e.message, stack: e.error?.stack, url: location.href })); } catch { /* ignore */ } });
window.addEventListener("unhandledrejection", (e) => { try { localStorage.setItem("studio.lastRejection", JSON.stringify({ at: new Date().toISOString(), reason: String((e.reason as Error)?.stack ?? e.reason), url: location.href })); } catch { /* ignore */ } });

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <ErrorBoundary name="studio"><ToastProvider><Gate><App /></Gate></ToastProvider></ErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);
